import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface DeleteShipVisitsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  count: number;
}

const DeleteShipVisitsDialog: FC<DeleteShipVisitsDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  count,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}>
      <DialogContent className='z-100'>
        <DialogHeader>
          <DialogTitle>
            {t('scenarios.create.customizePlanning.deleteDialog.title')}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {t('scenarios.create.customizePlanning.deleteDialog.description', {
            count,
          })}
        </DialogDescription>
        <DialogFooter>
          <Button
            variant='outline'
            onClick={() => {
              onOpenChange(false);
            }}>
            {t('scenarios.create.customizePlanning.deleteDialog.cancel')}
          </Button>
          <Button
            onClick={async () => {
              await onConfirm();
            }}
            variant='outline'
            className='border-destructive/40 text-destructive hover:bg-destructive/10 hover:text-destructive'>
            {t('scenarios.create.customizePlanning.deleteDialog.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteShipVisitsDialog;
